import { handleEntriesTopDistricts } from "../../../api/entries";
import { useQuery } from "@tanstack/react-query";
import { ChevronRight } from "lucide-react";
import { useState } from "react";
import {
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import AllDistricts from "./AllDistricts";
import { Empty } from "antd";

const renderCustomizedLabel = (props: any) => {
  const { x, y, width, value } = props;
  const radius = 10;

  return (
    <g>
      <text
        x={x + width / 2}
        y={y - radius}
        fill="#323232"
        textAnchor="middle"
        dominantBaseline="middle"
      >
        {value}
      </text>
    </g>
  );
};

const CustomizedLabel = (props: any) => {
  const { x, y, stroke, value } = props;

  return (
    <text
      x={x + 17}
      y={y}
      dy={-4}
      fill={stroke}
      fontSize={10}
      textAnchor={"middle"}
    >
      {value}
    </text>
  );
};

const CustomLegend = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "-10px", fontSize: "14px" }}>
      <div className="flex items-center justify-center">
        <div
          style={{
            width: 10,
            height: 10,
            marginRight: 5,
            marginTop: 1,
            background: "#82ca9d",
          }}
        ></div>
        <div style={{ color: "#82ca9d" }}>Entries</div>
      </div>
    </div>
  );
};

export default function TopDistricts({ filters }: any) {
  const [isVisible, setVisible] = useState<boolean>(false);
  const params = `startDate=${filters?.startDate}&endDate=${filters?.endDate}&branch=${filters?.branch}`;

  const { data: entries } = useQuery({
    queryKey: ["topDistricts", params],
    queryFn: () => handleEntriesTopDistricts({ params }),
  });

  return (
    <div className="">
      <div className="border-b-4 border-orange-100 bg-orange-50 p-2  flex justify-between">
        <div className="font-bold">TOP DISTRICTS</div>
        <button
          onClick={() => setVisible(true)}
          className="flex justify-center items-center text-gray-600"
        >
          View All <ChevronRight size={15} />
        </button>
      </div>
      <div className="py-2" style={{ height: 250 }}>
        {!entries || entries?.length === 0 ? (
          <Empty />
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              width={500}
              height={300}
              data={entries}
              margin={{
                top: 20,
                right: 20,
                left: 0,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend content={<CustomLegend />} />
              <Bar
                dataKey="totalEntries"
                label={CustomizedLabel}
                fill="#82ca9d"
                activeBar={<Rectangle fill="gold" stroke="purple" />}
              />
              <LabelList dataKey="Target" content={renderCustomizedLabel} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
      <AllDistricts
        isVisible={isVisible}
        setVisible={setVisible}
        params={params}
      />
    </div>
  );
}
